export default __webpack_public_path__ + "static/articles-lutein-spasim-zrenieto-83b2f98bc1c6b97bdc236a632a3160dd.jpg";